import { Action } from '../decorator/log';
import Base from './BaseStore';
import Vue from 'vue';
import { getEntityType } from '../utils/util';
import DetailStore from './DetailStore';
// import { csvParse } from '@root/node_modules/@types/d3-dsv';

let pathPrefix = null;

import clonedeep from 'lodash.clonedeep';
import mockAjax from './mock/ajax.mock.js';

if ($foodConfig.mode === 'ces') {
    pathPrefix = '/brain-api/ces';
} else {
    pathPrefix = '/brain-api';
}
interface SearchStoreInterface {
    [propName: string]: any;
    searchItem: SearchItem;
}

interface SearchItem {
    [propName: string]: any;
    subjectId?: string;
    className: string;
    filterCity: any;
    entityType: 'user' | 'poi';
}

class SearchStore extends Base {
    state: SearchStoreInterface = {
        count: 1,
        searchItem: {} as SearchItem,
        searchList: [] as Array<any>,
        historyList: [] as Array<any>,
        filterCity: undefined
    };

    @Action changeFilterCity(city) {
        this.state.filterCity = city;
    }

    @Action addHistory(item) {
        let list = this.state.historyList;
        list.push(item);
        list = list.reverse();
        let subMap = {};
        list = list.filter((_) => {
            if (!subMap[_.subjectId]) {
                subMap[_.subjectId] = true;
                return true;
            }
        });
        list = list.slice(0, 5);
        list = list.reverse();
        this.state.historyList = list;
    }

    @Action setSearchItem(searchItem) {
        // TODO 搜索结果为空处理
        this.addHistory(searchItem);

        // className数据清洗处理
        if (Array.isArray(searchItem.className)) {
            searchItem.className = searchItem.className[0];
        }

        searchItem.entityType = getEntityType(searchItem.customType || searchItem.className || searchItem.type);
        !searchItem.entityType && alert('数据出现错误');

        this.state.searchItem = searchItem;
    }

    @Action clearSuggest() {
        this.state.searchList = [];
        this.state.filterCity = undefined;
    }

    @Action
    async suggest({ str, city }: any) {
        let url = `${pathPrefix}/v1/searchSubjectId?id=${str}`;
        city && (url += `&city=${city}`);
        try {
            let res = await this.$api({
                path: url,
                method: 'get',
                params: {}
            });
            this.state.searchList = res.data;
            // debugger
        } catch (e) {
            Vue.prototype.$message.error('搜索推荐出现错误' + e);
        }
    }

    async searchCES (searchStr, isSetList = true) {
        try {
            let res;
            if (mockAjax[searchStr]) {
                res = mockAjax[searchStr];
            } else {
                res = await this.$api({
                    path: `${pathPrefix}/v1/searchSubjectId?id=${searchStr}`,
                    method: 'get', params: {}
                });
            }
            let searchItem = res.data[0];
            if (!searchItem) {
                return void 0;
            }
            this.addHistory(searchItem);
            this.setSearchItem(searchItem);
            if (isSetList) {
                this.state.searchList = res.data;
            }
        } catch (e) {
            Vue.prototype.$message.error('搜索出现错误' + e);
        }
    }

    // 不是sug 是确定要搜索的内容了 啊 其实和sug很像的
    @Action
    async search(searchStr) {
        try {
            let res = await this.$api({
                path: `${pathPrefix}/v1/getSubjectId?propertyValue=${searchStr}`,
                method: 'get',
                params: {}
            });

            if (res.code === 403) {
                DetailStore.changeAccess(403);
                return res;
            }
            DetailStore.changeAccess(200);
            let searchItem = res.data[0];
            if (!searchItem) {
                // hack 登陆时序
                // Vue.prototype.$message.error('您搜索的内容不存在');
                return void 0;
            }
            this.addHistory(searchItem);
            this.setSearchItem(searchItem);
            return this.state;
        } catch (e) {
            Vue.prototype.$message.error('搜索出现错误' + e);
        }
        return this.state;
    }

    @Action
    async searchFinanceEnter(searchStr) {
        await this.searchFinance(searchStr);
        let resItem = this.state.searchList[0];
        if (resItem) {
            resItem.customType = 'user';
            this.clearSuggest();
            this.setSearchItem(resItem);
        }
    }

    @Action
    async searchFinance(searchStr?) {
        if (!searchStr) {
            searchStr = '';
            // searchStr = '1262';
        }
        // searchStr = '18646886302';
        try {
            // http://brain.inf.st.sankuai.com/finance-api/v1/searchFinance/134
            let res = await this.$api({
                path: `/finance-api/v1/searchFinance?id=${searchStr}`,
                method: 'get',
                params: {}
            });
            if (res.code === 403) {
                return res;
            }

            let searchList = res.data.item;
            this.state.searchList = searchList;
            return searchList;
        } catch (e) {
            console.log(e);
            Vue.prototype.$message.error('请求发生错误' + e);
            (document.querySelector('#app') as any).style.opacity = .7;
            setTimeout(() => {
                alert('您无权使用该系统');
            }, 100);
            debugger;
        }
    }
}

const search = new SearchStore();
export default search;
